import { Coord } from "../../types/Interface";

export default function getProjection(Point: Coord, startCoord: Coord, endCoord: Coord) {
  const v = { x: endCoord.x - startCoord.x, y: endCoord.y - startCoord.y };
  const w = { x: Point.x - startCoord.x, y: Point.y - startCoord.y };

  const vSqMag = v.x * v.x + v.y * v.y;
  if (vSqMag === 0) return startCoord;

  let t = (w.x * v.x + w.y * v.y) / vSqMag;

  t = Math.max(0, Math.min(1, t));

  return {
    x: startCoord.x + t * v.x,
    y: startCoord.y + t * v.y
  }
}